import { _ as __rest } from './_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { enforceNumber, generateClasses } from '@ids/tools';
import { s as styleInject } from './style-inject.es.js';

var css_248z = "/*\n** Voxel Foundation Formats\n*/\n/*\n** Voxel Foundation Media Query Mixins\n*/\n.ids-number-badge {\n  background-color: var(--ids_color_action_primary_base);\n  border-radius: var(--ids_size_cornerRadius_layout_01);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: var(--ids_color_contrast_onBrand_primary);\n  display: inline-block;\n  font: var(--ids_textStyle_f02_s20_h26_wbd);\n  height: var(--ids_size_general_24x);\n  line-height: 1;\n  min-width: var(--ids_size_general_24x);\n  padding: 0.0625rem var(--ids_size_general_6x);\n  position: relative;\n  text-align: center;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n@media (max-width: 63.99rem) {\n  .ids-number-badge {\n    font: var(--ids_textStyle_f02_s14_h20_wbd);\n    height: var(--ids_size_general_20x);\n    line-height: 1.2;\n    min-width: var(--ids_size_general_20x);\n  }\n}\n.ids-number-badge--neutral {\n  background-color: var(--ids_color_action_neutral_variant);\n}\n.ids-number-badge--secondary {\n  background-color: var(--ids_color_action_secondary_base);\n}\n.ids-number-badge--on-brand {\n  background-color: var(--ids_color_contrast_onBrand_primary);\n  color: var(--ids_color_action_primary_base);\n}\n.ids-number-badge--on-brand.ids-number-badge--neutral {\n  color: var(--ids_color_action_neutral_base);\n}\n.ids-number-badge--on-brand.ids-number-badge--secondary {\n  color: var(--ids_color_action_secondary_base);\n}\n.ids-number-badge__content-hidden {\n  display: none;\n}\n.ids-number-badge__hidden-aria-label {\n  display: block;\n  font-size: 0.3125rem;\n  height: var(--ids_size_general_24x);\n  left: 0;\n  -webkit-line-clamp: 2;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: translate(-0.125rem, var(--ids_size_general_8x));\n          transform: translate(-0.125rem, var(--ids_size_general_8x));\n  width: var(--ids_size_general_24x);\n}";
styleInject(css_248z);

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsNumberBadge } from '@ids/react';
 * ```
 */
const IdsNumberBadge = _a => {
  var {
      contrast,
      variant,
      max,
      'aria-label': ariaLabel = '',
      className = '',
      children
    } = _a,
    props = __rest(_a, ["contrast", "variant", "max", 'aria-label', "className", "children"]);
  let definedInput = Number(children) ? Math.abs(enforceNumber(children)) : 0;
  const definedMax = max ? Math.abs(enforceNumber(Number(max))) : 99;
  const maxSymbol = '+';
  const accessibleValue = definedInput > definedMax ? `mais de ${definedMax} ${ariaLabel}` : `${definedInput} ${ariaLabel}`;
  definedInput = definedInput <= definedMax ? definedInput : `${definedMax}` + maxSymbol;
  const classes = generateClasses({
    'ids-number-badge': true,
    'ids-number-badge--on-brand': contrast === 'onBrand',
    'ids-number-badge--neutral': variant === 'neutral',
    'ids-number-badge--secondary': variant === 'secondary',
    [className]: className
  });
  return jsxs("span", Object.assign({
    className: classes
  }, props, {
    children: [jsx("span", {
      "aria-hidden": true,
      className: "ids-number-badge__content-hidden"
    }), jsx("span", Object.assign({
      "aria-hidden": Boolean(ariaLabel),
      className: "ids-number-badge__number-formatted"
    }, {
      children: definedInput
    })), ariaLabel && jsx("span", Object.assign({
      className: "ids-number-badge__hidden-aria-label"
    }, {
      children: accessibleValue
    }))]
  }));
};

export { IdsNumberBadge as I };
//# sourceMappingURL=number-badge.js.map
